import {
  Button,
  ButtonGroup,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from '@apollo/orbit';
import copy from 'copy-to-clipboard';
import React, { useEffect, useState } from 'react';

export const OperationIdPopover = ({
  operationId,
  triggerElement,
  handleOnClick,
}: {
  operationId: string;
  triggerElement: React.ReactElement;
  handleOnClick: () => void;
}) => {
  const [copyOperationIdSuccess, setCopyOperationIdSuccess] =
    useState<boolean>(false);

  const handleCopyOperationId = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    copy(operationId);
    setCopyOperationIdSuccess(true);
  };

  useEffect(() => {
    if (copyOperationIdSuccess) {
      const timeout = setTimeout(() => {
        setCopyOperationIdSuccess(false);
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [copyOperationIdSuccess]);

  return (
    <Popover isLazy trigger="hover" placement="bottom-start" size="sm">
      <PopoverTrigger>{triggerElement}</PopoverTrigger>
      <PopoverContent
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <PopoverHeader>
          Operation ID
          <PopoverCloseButton />
        </PopoverHeader>
        <PopoverBody>
          <Text variant="code">{operationId}</Text>
        </PopoverBody>
        <PopoverFooter>
          <ButtonGroup>
            <Button variant="secondary" onClick={handleCopyOperationId}>
              {copyOperationIdSuccess ? 'Copied' : 'Copy ID'}
            </Button>
            <Button
              variant="primary"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleOnClick();
              }}
            >
              View operation
            </Button>
          </ButtonGroup>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  );
};
